// extracted by mini-css-extract-plugin
module.exports = {"d2xZ6":"Z6_d2xZ6__d591N"};